import * as fromRouter from '@ngrx/router-store';
import { createSelector } from '@ngrx/store';
import { getRouterFeatureState } from '../reducer';

export const selectRouter = createSelector(
  getRouterFeatureState,
  state => state ? state.state : null
);

export const selectCurrentRouteCustom = createSelector(
  selectRouter,
  router => {
    let currentRoute = router ? router.root : null;
    return currentRoute;
  }
);

export const {
  selectCurrentRoute,   // select the current route
  //selectFragment,       // select the current route fragment
  selectQueryParams,    // select the current route query params
  selectQueryParam,     // factory function to select a query param
  selectRouteParams,    // select the current route params
  selectRouteParam,     // factory function to select a route param
  selectRouteData,      // select the current route data
  selectUrl,            // select the current url
} = fromRouter.getSelectors(getRouterFeatureState);


